import { useQuery } from 'hooks/useCustomQuery';

import getDashboardCompanyServices from 'API/Dashboard/getDashboardCompanyServices';

import useGetCurrentCompany from '@/queries/company/useGetCurrentCompany';
/**
 * Fetches consolidated dashboard payload (services + app auths) for a company.
 *
 * Response shape (backend):
 * { companyID, companyApproved, services: [], appAuths: [] }
 */
function useDashboardCompanyServices({
    currentCompany,
    flow,
    queryKey = ['dashboardServices', flow, `company: ${currentCompany}`],
    options = {},
}) {
    const { data: currentCompanyData } = useGetCurrentCompany();
    return useQuery({
        queryKey,
        queryFn: async () => {
            const res = await getDashboardCompanyServices(currentCompany);
            if (res.status !== 200) {
                throw new Error(
                    res.message || 'Error fetching dashboard services payload',
                );
            }

            return res.data || {};
        },
        // select (not queryFn) so this re-reads currentCompanyData live,
        // even if it resolves after this query's own cached result.
        select: (payload) => {
            const services = (payload.services || []).map((service) => {
                const normalized =
                    service.appAuthType === 'Webex'
                        ? { ...service, appAuthType: 'WebexAppAuth' }
                        : service;
                return {
                    ...normalized,
                    companyID: normalized.companyID ?? payload.companyID,
                    company: normalized.company ?? {
                        selectiveSyncPolicy:
                            currentCompanyData?.selectiveSyncPolicy,
                    },
                };
            });

            return {
                ...payload,
                services,
            };
        },
        ...options,
    });
}

export default useDashboardCompanyServices;
